import type { FC } from 'react'

import { ComingSoonPage } from 'components'

const News: FC = () => <ComingSoonPage image={`${process.env.PUBLIC_URL}/news.png`} title='news' />

export default News
